// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import adsConfig from '../../../config/ads';
import { buildPostAdModel } from '../../../utils/ad_util';

export default function(state = {}, action) {
  const { store } = action;
  const typeMap = {
    INNOVATION_BY_DESIGN_LOADING() {
      return {
        isLoading: true
      };
    },
    INNOVATION_BY_DESIGN_LOADED() {
      const currentState = store.getState();
      const site = get(currentState, 'config.site') || 'fastcompany';
      const adModelData = buildPostAdModel(
        adsConfig,
        site,
        'innovation-by-design',
        'categoryPage'
      );

      adModelData.model.adzone = 'innovation/innovation-by-design';
      return {
        isLoading: false,
        data: action.innovationByDesign,
        year: action.year,
        ads: adModelData
      };
    },
    INNOVATION_BY_DESIGN_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.innovationByDesign.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
